import { motion } from "framer-motion";
import { Button } from "src/@/components/ui/button";
import Iconify from "src/components/Iconify";

export function FileListItemItemText({
  key,
  file,
  name,
  size,
  onRemove
}) {
  const isString = (value) => typeof value === "string";

  const fData = (size) => {
    // Format size into a readable string
    return `${(size / 1024).toFixed(2)} KB`;
  };

  return (
    <motion.div
      key={key}
      className="flex items-center justify-between p-2 rounded-lg border bg-background"

    >
        <div className="flex flex-row">
        <div className="mr-3">
        <Iconify className="text-[24px]" icon="majesticons:file" />
      </div>
      <div className="flex items-center">
        <p className="text-sm font-medium">{name}</p>

      </div>

        </div>

      <div>
        <Button
          size="icon"
          variant="ghost"
          className="hover:text-destructive"
          onClick={() => onRemove(file)}
        >
            <Iconify icon="eva:close-fill" />
        </Button>
      </div>
    </motion.div>
  );
}
